import IconShareSolid from '@/assets/icons/font_awesome/share-nodes-solid.svg?react';
import { UI_PRIMITIVE__tooltip } from '@/components/ui/UI_PRIMITIVE__tooltip';
import { ENUM__page_type } from '@/enums/ENUM__page_type';
import { use_dispatch } from '@/hooks/_base/use_dispatch';
import { use_slice_generation, use_slice_workspace } from '@/hooks/store/use_slices';
import { toast } from '@/hooks/use-toast';
import i18n_base_ui from '@/locales/keys/i18n_base_ui.json';
import { ENUM__i18n_namespace } from '@/services/i18n/ENUM__i18n_namespace';
import { remote_workspace_child_entity_share_status_update } from '@/state/workspace/child_entity/remote_workspace_child_entity_share_status_update';
import { md } from '@/utils/utils_html';
import { not_implemented_type } from '@shared/asserts/utils_asserts';
import { DTO__workspace_child_enity } from '@shared/dto/+workspace/workspace_entity/_database_entity_with_grid2d_permissions/dto_workspace_child_enity';
import { ENUM__workspace_entity } from '@shared/dto/+workspace/workspace_entity/_enums/ENUM__workspace_entity';
import { RequestWorkspaceChildEntityUpdateShareStatus } from '@shared/dto/+workspace/workspace_entity/_requests/request_workspace_child_entity_update_share_status';
import { DTO__user_task } from '@shared/dto/user_task/DTO__user_task';
import { useTranslation } from 'react-i18next';
import { UI_PRIMITIVE__button_with_icon_animated } from '../../../components/ui/UI_PRIMITIVE__button_with_icon_animated';

interface Props {
  item: DTO__workspace_child_enity;
  required_permission: string;
  isSelected?: boolean;
}

export function ButtonWorkspaceChildEntityShare({ item, required_permission, isSelected = false }: Props) {
  const dispatch = use_dispatch();

  const { t } = useTranslation(ENUM__i18n_namespace.BASE_UI);

  const { generation_current } = use_slice_generation(['generation_current']);
  const { current_workspace_user } = use_slice_workspace(['current_workspace_user']);

  /*
   * EVENTS
   */
  async function onClick(e: React.MouseEvent) {
    e.stopPropagation();

    let request = new RequestWorkspaceChildEntityUpdateShareStatus();
    request.workspace_id = item.workspace_id;
    request.is_shared = !item.is_shared;
    request.entity_type = item.type;
    request.entity_id = item._id;

    await dispatch(remote_workspace_child_entity_share_status_update([request]));

    if (request.is_shared) {
      let url = `${window.location.origin}${get_url_share()}`;

      await navigator.clipboard.writeText(url);

      toast({ title: t(i18n_base_ui.toasts.child_entity_share.title) });
    } else {
      toast({ title: t(i18n_base_ui.toasts.child_entity_share_stopped.title) });
    }
  }

  function get_url_share() {
    let out = '';

    let { type } = item;

    switch (type) {
      case ENUM__workspace_entity.COLLECTION_UPLOADS:
      case ENUM__workspace_entity.COLLECTION_FAVORITES:
      case ENUM__workspace_entity.COLLECTION_GENERATED:
      case ENUM__workspace_entity.COLLECTION_VIEWED_ON_SEARCH:
      case ENUM__workspace_entity.COLLECTION_CUSTOM:
        out = ENUM__page_type.BUILD_PATH_COLLECTIONS(item._id);
        break;
      case ENUM__workspace_entity.ENTITY_SEARCH:
        out = ENUM__page_type.BUILD_PATH_SEARCH(item._id);
        break;
      case ENUM__workspace_entity.ENTITY_USER_TASK: {
        let target_generation_id =
          generation_current.user_task_id == item._id ? generation_current._id : (item as DTO__user_task).getMostRecentGeneration()._id;

        out = ENUM__page_type.BUILD_PATH_USER_TASK(target_generation_id);
        break;
      }
      default:
        not_implemented_type(type);
    }

    return out;
  }

  if (!current_workspace_user.is_feature_pertmitted(required_permission)) return <></>;

  /*
   * HTML
   */
  return (
    <UI_PRIMITIVE__tooltip tooltip_title={t(i18n_base_ui.button.workspace_child_entity_share.tooltip)} side="top">
      <UI_PRIMITIVE__button_with_icon_animated
        className="p-0 "
        size="square-5"
        variant="no-border-on-component"
        {...{ onClick }}
        iconClassNameBase={`!w-3 !h-3 ${md(`${isSelected ? 'text-bar' : 'text-component-item-foreground'}`, ``)}`}
        iconClassNameHovered={`!text-bar-foreground`}
        iconClassNameNonHovered={`${isSelected ? 'text-bar' : 'text-component-item-foreground'}`}
        Icon={IconShareSolid}
      />
    </UI_PRIMITIVE__tooltip>
  );
}
